<template>
  <div
    class="w-full min-h-screen pb-8 overflow-y-auto bg-cover"
    :style="'background-image: url(' + BackgroundImage + ')'"
  >
    <header
      class="flex items-center justify-between w-full px-4 py-4 max-w-[1500px] mx-auto mt-2"
    >
      <NuxtLink
        to="/"
        title="Beesphone"
        class="text-2xl font-bold text-primary font-manrope"
      >
        Beesphone
      </NuxtLink>

      <!-- <button class="cursor-pointer hover:opacity-75" type="button">
                <img alt="Menu" src="/images/ai-bot.png" class="w-8" />
            </button> -->
    </header>

    <div class="flex items-center justify-center flex-1 mt-6">
      <div
        class="w-full max-w-[25rem] py-8 px-5 sm:px-6 md:px-8 mx-5 bg-white dark:bg-slate-900 rounded-lg base-shadow"
      >
        <img src="/images/logo.png" alt="Logo" class="w-32 mb-10 mx-auto" >
        <h1
          class="text-2xl font-bold text-center text-neutral-600 font-manrope"
        >
          Forgot Password
        </h1>
        <p
          class="mt-2 text-center text-sm font-medium text-[#39404F] font-manrope"
        >
          Enter your email and we will send you a link to reset your password
        </p>

        <form
          class="mt-6"
          action=""
          method="post"
          @submit.prevent="handleSubmit"
        >
          <InputFields
            v-model="emailAddress"
            label="Email address"
            placeholder="Enter your email"
            :left-icon="HiOutlineMail"
            required
            type="email"
          />

          <Transition
            enter-active-class="transition-all duration-200 ease-out"
            enter-from-class="opacity-0 -translate-y-1"
            enter-to-class="opacity-100 translate-y-0"
            leave-active-class="transition-all duration-150 ease-in"
            leave-from-class="opacity-100 translate-y-0"
            leave-to-class="opacity-0 -translate-y-1"
          >
            <AlertMessage v-if="message" :type="notificationError" :message="message" class="mt-4">
              <AlertIcon class="w-5 h-auto mr-3 min-w-5 shrink-0" stroke-class="" />
            </AlertMessage>
          </Transition>

          <Button
            variant="primary"
            title="Reset Password"
            size="lg"
            class="w-full mt-6"
            :icon="HiOutlineArrowRight"
            icon-after-title
            type="submit"
          />
        </form>

        <p
          class="mt-5 text-center text-sm font-medium text-[#39404F] font-manrope"
        >
          Back to
          <NuxtLink
            to="signin"
            class="font-medium text-primary font-manrope hover:opacity-80 hover:bg-slate-50"
            >Sign In</NuxtLink
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import Button from "~/components/common/Button.vue";
import InputFields from "~/components/common/InputFields.vue";
import BackgroundImage from "~/assets/images/bg-auth.png";
import AlertMessage from "~/components/common/AlertMessage.vue";
import AlertIcon from "~/components/icons/AlertIcon.vue";
import { sendResetPasswordEmail } from "~/services/authentication";

import { HiOutlineMail, HiOutlineArrowRight } from "vue3-icons/hi";
import { ref } from "vue";

definePageMeta({
  layout: "auth",
  title: "Forgot Password",
});

const emailAddress = ref("");
const message = ref<string>("");
const notificationError = ref<"info" | "success" | "warning" | "error">(
  "success"
);
const router = useRouter();

const handleSubmit = async () => {
  try {
    await sendResetPasswordEmail(emailAddress.value);
    message.value = "Password reset mail has been sent successfully";
    setTimeout(() => {
      router.push("/auth/signin");
    }, 2000);
  } catch (err) {
    notificationError.value = "error";
    message.value = err.code || "";
  }
};
</script>
